import React, { useState } from 'react';
import { Form, Alert, Button, Spinner } from 'react-bootstrap';
import moment from 'moment';
import useAttestati from '../../hooks/useAttestati';

const AttestatiManager = ({ utente, esami, corso, classeUtente, pathAttestato, onGeneraAttestato }) => {
  const [selectedEsame, setSelectedEsame] = useState(null); 
  const { generaAttestato, downloadAttestato, loadingStateAttestati } = useAttestati();

  // --- Genera attestato ---
  /*
  const handleGeneraClick = async () => {
    if (!selectedEsame) return;

    const datiPerGenerare = {
      id_corso: corso.id_corso,
      id_classe_utente: classeUtente.id_classe_utente,
      id_utente: utente.id_utente,
      data_esame: selectedEsame.esame.data,
    };

    try {
      await generaAttestato(datiPerGenerare);
    } catch (err) {
      console.error("Errore nella generazione attestato:", err);
    }
  };
  */

 /*
  // --- Scarica attestato ---
  const handleDownloadClick = async () => {
    if (!classeUtente?.id_classe_utente) return;

    try {
      await downloadAttestato({
        id_classe_utente: classeUtente.id_classe_utente
      });
    } catch (err) {
      console.error("Errore nel download attestato:", err);
    }
  };
*/



  const handleDownloadClick = () => {
    // 1. controllo di sicurezza che il percorso del file esista
    if (!pathAttestato) {
      alert("il percorso del file dell'attestato non è disponibile.");
      return;
    }

    // 2. creo un link temporaneo e invisibile nella pagina
    const link = document.createElement('a');
    link.href = pathAttestato;

    // 3. estraggo il nome del file dall'indirizzo completo (es. "attestato_111_ASC90A...")
    //    e lo imposto come nome per il download
    link.setAttribute('download', pathAttestato.split('/').pop());
    link.setAttribute('target', '_blank');

    // 4. simulo il click sul link per avviare il download e poi lo rimuovo
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // --- Gestione selezione esame ---
  const handleEsameSelection = (e) => {
    const esameId = e.target.value;
    const esameCompleto = esami.find(
      esame => esame.id_calendario_esame_utente.toString() === esameId
    );
    setSelectedEsame(esameCompleto);
  };

  const renderEsameOption = (esame) => {
    const data = moment(esame.esame.data).format('DD/MM/YYYY');
    const oraInizio = moment(esame.esame.ora_inizio, 'HH:mm:ss').format('HH:mm');
    const oraFine = moment(esame.esame.ora_fine, 'HH:mm:ss').format('HH:mm');
    return `Esame del ${data} (${oraInizio}-${oraFine}) - ${esame.esito_esame.toUpperCase().replace('_', ' ')}`;
  };

  const getEsitoClass = (esito) => {
    switch(esito.toLowerCase()) {
      case 'promosso':
        return 'text-success';
      case 'non_svolto':
        return 'text-warning';
      case 'bocciato':
        return 'text-danger';
      default:
        return '';
    }
  };

  return (
    <div className="container">
      <div>
        <h5 className="card-title mb-3">Seleziona Esame per Generare Attestato</h5>
        {esami?.length > 0 ? (
          <>
            {/* --- Dati utente --- */}
            <div className="card mb-4">
              <div className="card-body">
                <h5 className="card-title mb-3">Dati Utente</h5>
                <div className="row">
                  <div className="col-md-6">
                    <p className="mb-1"><strong>Nome:</strong> {utente?.nome}</p>
                    <p className="mb-1"><strong>Cognome:</strong> {utente?.cognome}</p>
                    <p className="mb-1"><strong>Email:</strong> {utente?.email}</p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-1"><strong>Luogo di nascita:</strong> {utente?.luogo_nascita}</p>
                    <p className="mb-1">
                      <strong>Data di nascita:</strong> {moment(utente?.data_nascita).format('DD/MM/YYYY')}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* --- Selezione esame --- */}
            <Form.Group>
              <Form.Select 
                value={selectedEsame ? selectedEsame.id_calendario_esame_utente : ''} 
                onChange={handleEsameSelection}
                className="mb-3"
              >
                <option value="">Seleziona un esame...</option>
                {esami.map((esame) => (
                  <option 
                    key={esame.id_calendario_esame_utente} 
                    value={esame.id_calendario_esame_utente}
                    disabled={esame.esito_esame !== 'promosso'}
                  >
                    {renderEsameOption(esame)}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* --- Dettagli esame selezionato --- */}
            {selectedEsame && (
              <div className="mt-3 border rounded p-3">
                <h6>Dettagli Esame</h6>
                <p className="mb-1"><strong>Data:</strong> {moment(selectedEsame.esame.data).format('DD/MM/YYYY')}</p>
                <p className="mb-1"><strong>Orario:</strong> {moment(selectedEsame.esame.ora_inizio, 'HH:mm:ss').format('HH:mm')} - {moment(selectedEsame.esame.ora_fine, 'HH:mm:ss').format('HH:mm')}</p>
                <p className="mb-1"><strong>Esito:</strong> <span className={getEsitoClass(selectedEsame.esito_esame)}>{selectedEsame.esito_esame.toUpperCase()}</span></p>
                
                {/* --- Bottoni azione --- */}
                <div className="mt-4 d-flex gap-2">
                  <Button 
                    variant="primary" 
                    onClick={() => onGeneraAttestato(selectedEsame)}
                    disabled={loadingStateAttestati.isLoadingGeneraAttestato}
                  >
                    {loadingStateAttestati.isLoadingGeneraAttestato ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        {' '}Generazione...
                      </>
                    ) : (
                      'Genera/Aggiorna Attestato'
                    )}
                  </Button>
                </div>
              </div>
            )}
          </>
        ) : (
          <Alert variant="info">Nessun esame con esito "promosso" disponibile per questo utente.</Alert>
        )}
      </div>
    </div>
  );
};

export default AttestatiManager;
